<template>
  <div
    class="flex w-fit min-w-fit items-center space-x-1 rounded-xl bg-purple-700 py-1 pr-2 pl-1 whitespace-nowrap"
  >
    <img src="./assets/plane.svg" alt="" width="16" height="16" />
    <span class="text-static-white text-xs font-medium">
      {{ t('charter.charterFlight') }}
    </span>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import messages from '../locales.json';

  const { t } = useI18n({ messages });
</script>
